const SUPPLY_DEMAND_SIDE_TRANSLATION_KEYS = {
  DEMAND: "supply_demand_type_demand",
  SUPPLY: "supply_demand_type_supply"
};

export default class FilterOptionsHelper {
  static isTrendStatusColumn(column) {
    return (
      column?.attribute_name === "trend_status" ||
      column?.values_type === "trend_status"
    );
  }

  static getOptionTranslationKey(column, optionValue) {
    if (FilterOptionsHelper.isTrendStatusColumn(column)) {
      return `trend_status_${optionValue}`;
    }

    const sideKey = SUPPLY_DEMAND_SIDE_TRANSLATION_KEYS[optionValue];
    if (sideKey) {
      return sideKey;
    }

    return String(optionValue);
  }

  static getFilterOptionKeys(column) {
    const filterData = column?.filter_data;

    if (Array.isArray(filterData)) {
      return filterData.filter(option => {
        if (typeof option === "boolean" || option === 0) {
          return true;
        }

        return !!option;
      });
    }

    if (filterData && typeof filterData === "object") {
      return Object.keys(filterData);
    }

    return [];
  }
}
